import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { isNoindexRoute } from "@/utils/routes";

/**
 * Emite `noindex, follow` para las URLs marcadas en el quality gate P3
 * (herramientas sin resultado real, rutas legales ES sin traducción aprobada
 * y rutas del inventario que todavía no resuelven a una página).
 * La URL se conserva accesible: solo se retira del índice.
 *
 * Se aplica sobre el DOM tras el render de la página para ganar a cualquier
 * `<meta name="robots">` que emita el head de la propia página.
 */
export const RouteRobotsMeta = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!isNoindexRoute(pathname)) return;

    const names = ["robots", "googlebot", "bingbot"];
    const created: HTMLMetaElement[] = [];
    const previous: Array<{ el: HTMLMetaElement; value: string }> = [];

    names.forEach((name) => {
      const existing = document.querySelectorAll<HTMLMetaElement>(`meta[name="${name}"]`);
      if (existing.length) {
        existing.forEach((el) => {
          previous.push({ el, value: el.content });
          el.content = "noindex, follow";
        });
        return;
      }
      const el = document.createElement("meta");
      el.name = name;
      el.content = "noindex, follow";
      document.head.appendChild(el);
      created.push(el);
    });

    return () => {
      previous.forEach(({ el, value }) => {
        el.content = value;
      });
      created.forEach((el) => el.remove());
    };
  });

  return null;
};
